import { useState as i, useEffect as o } from "react";
const c = () => {
  const [n, t] = i(!1);
  return o(() => {
    const e = window.matchMedia("(max-width: 767px)"), s = (a) => {
      t(a.matches);
    };
    return t(e.matches), e.addEventListener("change", s), () => {
      e.removeEventListener("change", s);
    };
  }, []), {
    isMobile: n
  };
};
export {
  c as useIsMobile
};
